import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ofset',
  templateUrl: './ofset.component.html',
  styleUrls: ['./ofset.component.scss']
})
export class OfsetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/ofset/ofset.component.ts